// extracted by mini-css-extract-plugin
export default {"link":"yrkrta","agreementCheckbox":"jcrgCC"};